import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { ArrowLeft, BookOpen } from 'lucide-react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../modules/translation/TranslationContext';
import { ActiveOrderTestIds } from '../../../../../../../utils/testIds/ActiveOrder.testIds';

interface BackToCatalogButtonProps {
  onClick: () => void;
  catalogName?: string;
}

const BackToCatalogButton = ({ catalogName, onClick }: BackToCatalogButtonProps) => {
  const { translate } = useTranslation();

  const label = catalogName
    ? translate(LangEnum.GLOBAL_BACK_TO_CATALOG_NAME, { catalogName })
    : translate(LangEnum.GLOBAL_BACK_TO_CATALOG);

  return (
    <Tooltip TooltipContent={label}>
      <Button
        testId={ActiveOrderTestIds.BACK_TO_CATALOG_BUTTON}
        variant="contained"
        color="secondary"
        size="medium"
        shape="square"
        aria-label={label}
        startIcon={<Icon icon={ArrowLeft} size="sm" />}
        onClick={onClick}
      >
        <Icon icon={BookOpen} size="sm" />
      </Button>
    </Tooltip>
  );
};

export default BackToCatalogButton;
